import React, { useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import { createSearchParams, Link, useNavigate } from 'react-router-dom'
import CircularProgress from '@mui/material/CircularProgress'
import FormInput from '@/components/Common/FormInput'
import Description from '@/components/Description/Description'
import StyledBgContainer from '@/components/StyledBgContainer/StyledBgContainer'
import StyledButton from '@/components/Button/Button'
import TopNav from '@/components/TopNav/TopNav'
import useForgotPassword from '../services/hooks/useForgotPassword'
import useLocalStorage from '@/hooks/useLocalStorage'
import useValidation from '@/hooks/useValidation'
import Path from '@/router/localRoutes'
import EmailIcon from '@/assets/Message 36.svg'
import './ForgotPassword.css'

const ForgotPassword = () => {
  const inputValidationRules = {
    email: [
      { required: true, message: 'Please enter your email address.' },
      {
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: 'Please enter a valid email address.',
      },
    ],
  }

  const [emailValue, setEmailValue] = useState<string>('')
  const [errorMsg, setErrorMsg] = useState<string>('')
  const { mutate: forgotPassword, isPending } = useForgotPassword()
  const [role] = useLocalStorage('role')
  const { errors, validateInputs } = useValidation(
    {
      email: emailValue,
    },
    inputValidationRules,
  )

  const navigate = useNavigate()

  const onChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmailValue(event.target.value)
  }

  const handleSendingCode = async () => {
    if (!validateInputs()) {
      return
    }
    const payload = {
      email: emailValue,
      role,
    }

    forgotPassword(payload, {
      onSuccess: () => {
        navigate({
          pathname: `${Path.VerifyCode}`,
          search: createSearchParams({
            email: payload.email,
          }).toString(),
        })
      },
      onError: (error) => {
        setErrorMsg(error.message)
      },
    })
  }

  useEffect(() => {
    if (!role) {
      navigate(Path.Root)
    }
  }, [role, navigate])

  return (
    <StyledBgContainer>
      <div className="forgot-password-container">
        <TopNav showArrow={true} />
        <h1 className="heading  mb-3 font-bold">Reset Password</h1>

        <Description>Enter your registered email to reset password</Description>

        <Grid className="form-container w-[556px] gap-3">
          <FormInput
            type="email"
            value={emailValue}
            onChange={onChangeEmail}
            label="Email Address"
            startIconComponent={
              <img src={EmailIcon} alt="Email icon" className="text-white" />
            }
            error={
              !!errors.email ||
              errorMsg === 'Invalid email format' ||
              errorMsg.includes('User')
            }
            helperText={errors.email || errorMsg}
          />
          {/* {isError ? <p className="error-msg !text-left">{errorMsg}</p> : null} */}
          <div className="absolute bottom-16 left-0 right-0 flex flex-col items-center gap-14">
            {isPending ? (
              <StyledButton className=" w-[120px] !h-[45px]">
                <CircularProgress className="!text-[#181a21] !text-2xl" />
              </StyledButton>
            ) : (
              <StyledButton
                onClick={handleSendingCode}
                disabled={!emailValue}
                className="!shadow-2xl !font-sans w-[120px] !h-[45px] !text-[14px]"
              >
                Send Code
              </StyledButton>
            )}
            <p>
              Back to&nbsp;
              <Link className="link-style" to={Path.Signin}>
                Sign In&nbsp;
              </Link>
            </p>
          </div>
        </Grid>
      </div>
    </StyledBgContainer>
  )
}

export default ForgotPassword
